// extracted by mini-css-extract-plugin
module.exports = {"profile_menu":"ProfileMenu_profile_menu__20KF0","span":"ProfileMenu_span__3OJYW","sections":"ProfileMenu_sections__1wBN8"};